import { object, func, string } from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { ServerRequest } from '../../../utils/apiweb'
import { REQUEST_METHOD } from '@laramie/ui';
import { onRequestError, onRequestNoSuccess } from '../../../utils/requests'
import { APIS } from '../../../config/apis'
import {TIPS} from "../../../consts/tips";

import { CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, InputSubTasa, InputTasa, Modal } from '../../common'
import { useForm, useFormErrors, useManagedContext } from '../../hooks'
import { isNull, isValidNumber } from '../../../utils/validator'
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage'

const entityInit = {
	id: -1,
    codigo: '',
    orden: '',
    nombre: '',
    idTasaInicialRenovacion: 0,
    idSubTasaInicialRenovacion: 0,
    idTasaTransferencia: 0,
    idSubTasaTransferencia: 0,
    idTasaMensual: 0,
    idSubTasaMensual: 0,
    idTasaExpensas: 0,
    idSubTasaExpensas: 0,
    idSubTasaVarios: 0,
    esEmbarcacion: false,
}

const TipoArrendamientoModal = (props) => {
	const { setIsLoading } = useManagedContext()

	const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _, formSet] = useForm({
        codigo: '',
        orden: '',
        nombre: '',
        idTasaInicialRenovacion: 0,
        idSubTasaInicialRenovacion: 0,
        idTasaTransferencia: 0,
        idSubTasaTransferencia: 0,
        idTasaMensual: 0,
        idSubTasaMensual: 0,
        idTasaExpensas: 0,
        idSubTasaExpensas: 0,
        idSubTasaVarios: 0,
        esEmbarcacion: false,
    })

	useEffect(() => {
		const item = props.tipoArrendamiento

		setEntity(item)
		formSet({
			codigo: item.codigo,
			orden: item.orden,
			nombre: item.nombre,
			idTasaInicialRenovacion: item.idTasaInicialRenovacion,
			idSubTasaInicialRenovacion: item.idSubTasaInicialRenovacion,
			idTasaTransferencia: item.idTasaTransferencia,
			idSubTasaTransferencia: item.idSubTasaTransferencia,
			idTasaMensual: item.idTasaMensual,
			idSubTasaMensual: item.idSubTasaMensual,
			idTasaExpensas: item.idTasaExpensas,
			idSubTasaExpensas: item.idSubTasaExpensas,
			idSubTasaVarios: item.idSubTasaVarios,
			esEmbarcacion: item.esEmbarcacion,
		})
	}, [props.tipoArrendamiento])

	const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

	function getErrors() {
		const errors = {}

		if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
		if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
		if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT

		return errors
	}

	function getFormatErrors() {
		const errors = {}
		if (props.editMode === 'view') return errors

		if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

		return errors
	}

	function isEmptyValue(valor) {
		return isNull(valor) || valor.toString().length === 0
	}

	const onConfirm = () => {
        if (!validate()) return

		setIsLoading(true)

		ServerRequest(
			props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
			null,
			true,
			APIS.URLS.TIPO_ARRENDAMIENTO,
			props.editMode === 'modify' ? `/${entity.id}` : '',
			{...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0},
			res => res.json().then(() => {
				setIsLoading(false)
				props.onConfirm()
			}),
			res => {
				onRequestNoSuccess(res)
				setIsLoading(false)
			},
			error => {
				onRequestError(error)
				setIsLoading(false)
			},
		)
	}

    const disabled = props.editMode === 'view'

    return (
        <Modal
            onEscape={props.onCancel}
            size='lg'
            title="Tipo de arrendamiento"
			tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                          name="orden"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
						  value={formValues.orden}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                    <div className="col-12 col-md-8">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idTasaInicialRenovacion" className="form-label">Tasa inicial renovación</label>
						<InputTasa
							name="idTasaInicialRenovacion"
							placeholder=""
							className="form-control"
							value={formValues.idTasaInicialRenovacion}
							onChange={formHandle}
							disabled={disabled}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idSubTasaInicialRenovacion" className="form-label">Sub tasa inicial renovación</label>
						<InputSubTasa
							name="idSubTasaInicialRenovacion"
							placeholder=""
							className="form-control"
							value={formValues.idSubTasaInicialRenovacion}
							onChange={formHandle}
							disabled={disabled}
							idTasa={formValues.idTasaInicialRenovacion}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idTasaTransferencia" className="form-label">Tasa transferencia</label>
						<InputTasa
							name="idTasaTransferencia"
							placeholder=""
							className="form-control"
							value={formValues.idTasaTransferencia}
							onChange={formHandle}
							disabled={disabled}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idSubTasaTransferencia" className="form-label">Sub tasa transferencia</label>
						<InputSubTasa
							name="idSubTasaTransferencia"
							placeholder=""
							className="form-control"
							value={formValues.idSubTasaTransferencia}
							onChange={formHandle}
							disabled={disabled}
							idTasa={formValues.idTasaTransferencia}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idTasaMensual" className="form-label">Tasa mensual</label>
						<InputTasa
							name="idTasaMensual"
							placeholder=""
							className="form-control"
							value={formValues.idTasaMensual}
							onChange={formHandle}
							disabled={disabled}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idSubTasaMensual" className="form-label">Sub tasa mensual</label>
						<InputSubTasa
							name="idSubTasaMensual"
							placeholder=""
							className="form-control"
							value={formValues.idSubTasaMensual}
							onChange={formHandle}
							disabled={disabled}
							idTasa={formValues.idTasaMensual}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idTasaExpensas" className="form-label">Tasa expensas</label>
						<InputTasa
							name="idTasaExpensas"
							placeholder=""
							className="form-control"
							value={formValues.idTasaExpensas}
							onChange={formHandle}
							disabled={disabled}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idSubTasaExpensas" className="form-label">Sub tasa expensas</label>
						<InputSubTasa
							name="idSubTasaExpensas"
							placeholder=""
							className="form-control"
							value={formValues.idSubTasaExpensas}
							onChange={formHandle}
							disabled={disabled}
							idTasa={formValues.idTasaExpensas}
						/>
						<FormError />
					</div>
					<div className="mb-3 col-12 col-md-6">
					    <CheckboxButtonGroup label="Clasificación">
					        <CheckboxButton
					            name="esEmbarcacion"
					            label="Es embarcación"
					            checked={formValues.esEmbarcacion}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					    </CheckboxButtonGroup>
					</div>
					<div className="mb-3 col-12 col-md-6">
						<label htmlFor="idSubTasaVarios" className="form-label">Sub tasa varios</label>
						<InputSubTasa
							name="idSubTasaVarios"
							placeholder=""
							className="form-control"
							value={formValues.idSubTasaVarios}
							onChange={formHandle}
							disabled={disabled}
						/>
						<FormError />
					</div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={() => onConfirm()}>Guardar</button>
                    )}
                </div>
                
            )}
        />
    )
}

TipoArrendamientoModal.propTypes = {
    tipoArrendamiento: object.isRequired,
    editMode: string,
    onConfirm: func.isRequired,
    onCancel: func.isRequired
}

TipoArrendamientoModal.defaultProps = {
    editMode: 'view'
};

export default TipoArrendamientoModal
